import * as R from 'ramda'
import { SET_USER_INFO, SET_ENTITIES } from '../../actions'

const userReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_USER_INFO: {
      return R.mergeDeepRight(state, action.userInfo)
    }
    case SET_ENTITIES: {
      if (action.entities.userInfo) {
        return R.mergeDeepRight(state, action.entities.userInfo)
      }

      return state
    }
    default:
      return state
  }
}

export default userReducer

export const getCompanyId = (state) => R.path(['company', 'id'], state) || -1

export const getCurrentUserId = (state) => state.user_id

export const getCurrentUserFullName = (state) => state.full_name

export const getCurrentUserEmail = (state) => state.email



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/userInfo.js